import React, {
    useCallback, ReactNode,
} from 'react'

import {
    FormControlLabel,
    RadioGroup,
    Radio as MaterialRadio,
    Typography,
} from '@mui/material'
import { SerializedStyles } from '@emotion/react'

import useStyle from 'shared/hooks/useStyle'
import styles from './ExtendedRadio.style'

type Props = {
    onChange: (value: string, event: React.ChangeEvent<HTMLInputElement>) => void
    disabled?: boolean
    title?: string
    options?: {
        value: string
        label: string
    }[]
    name?: string
    value?: string
    compact?: boolean
    small?: boolean
    className?: string
    showInColumns?: boolean
    children?: ReactNode
    customClasses?: {
        radioItemLabel?: SerializedStyles,
    },
}

const defaultOptions = []

const ExtendedRadio = ({
    onChange,
    disabled = false,
    title = '',
    options = defaultOptions,
    name = 'labelType',
    value = '',
    compact = false,
    small = false,
    className = '',
    showInColumns = false,
    children,
    customClasses,
}: Readonly<Props>) => {
    const classes = useStyle(styles)

    const handleOnChange = useCallback((event) => {
        onChange(event.target.value, event)
    }, [onChange])

    return (
        <>
            {title && (
                <Typography
                    css={classes.label}
                    variant="caption"
                >
                    {title}
                </Typography>
            )}
            <RadioGroup
                aria-label="labelType"
                name={name}
                value={value}
                css={[
                    classes.radio,
                    className,
                    showInColumns && classes.showInColumns,
                ]}
                onChange={handleOnChange}
                data-testid={`radio-${name}`}
            >
                {options.map((radio) => {
                    return (
                        <div key={`div-radio-${radio.value}`}>
                            <FormControlLabel
                                key={`radio-${radio.value}`}
                                value={radio.value}
                                css={[
                                    classes.formControlStyle,
                                    small && classes.radioSmall,
                                ]}
                                label={(
                                    <span css={[
                                        classes.radioItemLabel,
                                        customClasses?.radioItemLabel,
                                    ]}
                                    >
                                        {radio.label}
                                    </span>
                                )}
                                control={(
                                    <MaterialRadio
                                        color="primary"
                                        css={compact ? classes.radioRoot : undefined}
                                    />
                                )}
                                data-value={radio.value}
                                disabled={disabled}
                            />
                            {radio.value === value && children}
                        </div>
                    )
                })}
            </RadioGroup>
        </>
    )
}

export default ExtendedRadio
